// Brand: Massa. Texts, links and logos; contract in src/lib/brand.ts.
import type { Brand } from "../../lib/brand";
import meta from "./brand.json";
import emblem from "./assets/emblem.svg";
import mediumIcon from "./assets/social/medium.svg";
import githubIcon from "./assets/social/github.svg";
import twitterIcon from "./assets/social/twitter.svg";
import telegramIcon from "./assets/social/telegram.svg";
import discordIcon from "./assets/social/discord.svg";
import redditIcon from "./assets/social/reddit.svg";
import youtubeIcon from "./assets/social/youtube.svg";
import linkedinIcon from "./assets/social/linkedin.svg";

export const BRAND: Brand = {
  name: meta.name,
  title: meta.title,
  description: meta.description,
  emblem,
  emblemSuffix: "Explorer",
  hero: {
    title: "Explore the Massa blockchain",
    subtitle: "Search through real-time and historical records on Massa blockchain",
  },
  // Same links as explorer.massa.net; accent colours come from each product's logo.
  getStarted: [
    {
      name: "Massa Station",
      desc: "Desktop app to manage your wallet, run a node and use Massa dApps.",
      href: "https://station.massa.net/",
      color: "#1AE19D",
    },
    {
      name: "Massa Bridge",
      desc: "Move assets between Ethereum, BNB Chain and Massa.",
      href: "https://bridge.massa.net/",
      color: "#4AB2FF",
    },
  ],
  // Footer content mirrors explorer.massa.net.
  footer: {
    wordmark: "MASSA",
    social: [
      ["Medium", "https://massalabs.medium.com/", mediumIcon],
      ["GitHub", "https://github.com/massalabs/massa", githubIcon],
      ["X", "https://twitter.com/massalabs", twitterIcon],
      ["Telegram", "https://t.me/massanetwork", telegramIcon],
      ["Discord", "https://discord.gg/massa", discordIcon],
      ["Reddit", "https://www.reddit.com/r/massa", redditIcon],
      ["YouTube", "https://www.youtube.com/channel/UChVfdvYpn0eFk4B-T7TGmOg", youtubeIcon],
      ["LinkedIn", "https://www.linkedin.com/company/massa-labs", linkedinIcon],
    ],
    columns: [
      ["Learn", [
        ["Vision", "https://massa.net/Learn/Vision"],
        ["Technology", "https://massa.net/Learn/Technology"],
        ["Autonomous Smart Contracts", "https://massa.net/Learn/AutonomousSmartContracts"],
        ["Decentralized Web", "https://massa.net/Learn/DecentralizedWeb"],
        ["Team", "https://massa.net/Learn/Team"],
      ]],
      ["Community", [
        ["Developer Documentation", "https://docs.massa.net/docs/build/home"],
        ["Run a Node", "https://docs.massa.net/docs/node/home"],
        ["Apply for a grant", "https://massa.foundation/Grants"],
      ]],
      ["Build", [
        ["Blog", "https://massalabs.medium.com/"],
        ["Ambassadorship", "https://massa.foundation/Ambassadorship"],
        ["Dashboard", "https://dashboard.massa.foundation/"],
        ["Useful Links", "https://massa.net/Community/UsefulLinks"],
      ]],
      ["More", [
        ["Media Kit", "https://massa.net/More/MediaKit"],
        ["Careers", "https://massa.net/More/Careers"],
        ["Privacy Policy", "https://massa.net/More/PrivacyPolicy"],
        ["Terms of Services", "https://massa.net/More/TermsofService"],
      ]],
    ],
  },
};
